import React, {
    useState
} from "react";

import {
    useAuth
} from "../context/AuthContext";

import "./Login.css";


// ============================================================
// LOGIN
// ============================================================

function Login() {

    const {
        login
    } = useAuth();


    const [
        email,
        setEmail
    ] = useState("");


    const [
        password,
        setPassword
    ] = useState("");


    const [
        loading,
        setLoading
    ] = useState(false);


    const [
        error,
        setError
    ] = useState("");


    // ========================================================
    // SUBMIT
    // ========================================================

    const handleSubmit =
        async event => {

            event.preventDefault();

            setError("");


            const normalizedEmail =
                email.trim();


            if (
                !normalizedEmail ||
                !password
            ) {

                setError(
                    "Informe seu e-mail e senha."
                );

                return;

            }


            try {

                setLoading(true);

                await login(
                    normalizedEmail,
                    password
                );

            } catch (error) {

                console.error(
                    "LOGIN ERROR:",
                    error
                );

                setError(
                    error.message ||
                    "Não foi possível realizar o login."
                );

            } finally {

                setLoading(false);

            }

        };


    // ========================================================
    // RENDER
    // ========================================================

    return (

        <main className="login-page">

            <div className="login-background">

                <div className="login-glow login-glow-one" />

                <div className="login-glow login-glow-two" />

            </div>


            <section className="login-card">

                {/* ==================================================
                    LOGO / MARCA
                ================================================== */}

                <div className="login-brand">

                    <div className="login-brand-icon">
                        💬
                    </div>

                    <div>

                        <h1>
                            ChatBot
                        </h1>

                        <span>
                            MultSite
                        </span>

                    </div>

                </div>


                {/* ==================================================
                    CABEÇALHO
                ================================================== */}

                <div className="login-header">

                    <h2>
                        Bem-vindo de volta
                    </h2>

                    <p>
                        Entre com suas credenciais
                        para acessar o painel.
                    </p>

                </div>


                {/* ==================================================
                    ERRO
                ================================================== */}

                {
                    error && (

                        <div className="login-error">

                            <span className="login-error-icon">
                                !
                            </span>

                            <span>
                                {error}
                            </span>

                        </div>

                    )
                }


                {/* ==================================================
                    FORM
                ================================================== */}

                <form
                    className="login-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    {/* ==================================================
                        E-MAIL
                    ================================================== */}

                    <div className="login-field">

                        <label htmlFor="email">
                            E-mail
                        </label>

                        <div className="login-input-wrapper">

                            <span className="login-input-icon">
                                @
                            </span>

                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={
                                    event =>
                                        setEmail(
                                            event.target.value
                                        )
                                }
                                autoComplete="username"
                                placeholder="seu@email.com"
                                disabled={loading}
                                autoFocus
                            />

                        </div>

                    </div>


                    {/* ==================================================
                        SENHA
                    ================================================== */}

                    <div className="login-field">

                        <label htmlFor="password">
                            Senha
                        </label>

                        <div className="login-input-wrapper">

                            <span className="login-input-icon">
                                •
                            </span>

                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={
                                    event =>
                                        setPassword(
                                            event.target.value
                                        )
                                }
                                autoComplete="current-password"
                                placeholder="Digite sua senha"
                                disabled={loading}
                            />

                        </div>

                    </div>


                    {/* ==================================================
                        BOTÃO
                    ================================================== */}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >

                        {
                            loading ? (

                                <>

                                    <span className="login-spinner" />

                                    Entrando...

                                </>

                            ) : (

                                <>
                                    Entrar
                                    <span className="login-button-arrow">
                                        →
                                    </span>
                                </>

                            )
                        }

                    </button>

                </form>


                {/* ==================================================
                    RODAPÉ
                ================================================== */}

                <div className="login-footer">

                    <span>
                        Acesso seguro
                    </span>

                    <span className="login-footer-dot">
                        •
                    </span>

                    <span>
                        MultSite
                    </span>

                </div>

            </section>

        </main>

    );

}


export default Login;